<template>
  <div class="pagination">
    <div class="number pr-4" v-if="this.allSelected"> All {{selectAll ? Items.total : Items.data.length}} jobs on this page are selected</div>
    <a v-if="this.allSelected && !selectAll" @click="changeSelectAll" href="javascrip:void(0)" class="number pr-4" style="color: red"> Select all {{Items.total}} jobs</a>
    <div class="number pr-4">{{Items.total == 0 ? 0 : ((pages.page - 1) * pages.limit) + 1}} - {{(pages.page * pages.limit) > Items.total ? Items.total : (pages.page * pages.limit) }} of {{Items.total}}</div>
    <div class="control">
      <span class="prev mr-2" @click="prevPage" v-bind:class="{'disabled': pages.page <= 1}">
        <div class="tooltip">Previous page</div>
        <svg width="6" height="10" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.29344 0.293762C6.68344 0.683762 6.68344 1.31376 6.29344 1.70376L2.41344 5.58376L6.29344 9.46376C6.68344 9.85376 6.68344 10.4838 6.29344 10.8738C5.90344 11.2638 5.27344 11.2638 4.88344 10.8738L0.293437 6.28376C-0.0965624 5.89376 -0.0965624 5.26376 0.293437 4.87376L4.88344 0.283762C5.26344 -0.0962378 5.90344 -0.0962378 6.29344 0.293762Z" fill="black" fill-opacity="0.54"></path>
        </svg>
      </span>
      <span class="next ml-2" @click="nextPage" v-bind:class="{'disabled':pages.page >= value.totalPage}">
        <div class="tooltip">Next page</div>
        <svg width="6" height="10" viewBox="0 0 5 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.2925 0.293762C-0.0975 0.683762 -0.0975 1.31376 0.2925 1.70376L4.1725 5.58376L0.2925 9.46376C-0.0975 9.85376 -0.0975 10.4838 0.2925 10.8738C0.6825 11.2638 1.3125 11.2638 1.7025 10.8738L6.2925 6.28376C6.6825 5.89376 6.6825 5.26376 6.2925 4.87376L1.7025 0.283762C1.3225 -0.0962378 0.6825 -0.0962378 0.2925 0.293762Z" fill="black" fill-opacity="0.54">
          </path>
        </svg>
      </span>
    </div>
    <div class="float-left px-1 py-0 ml-2 control">
      <gofix-form-dropdown
              label=""
              class="gofixInputMinWith gofixDropdownBorder gofixInputNoBg gofixDropdownLimit m-0"
              :options="[25,50,100,150,200,500]"
              :filterable="false"
              :clearable="false"
              :searchable="false"
              v-model="pages.limit"
      >
      </gofix-form-dropdown>
    </div>
  </div>
</template>
<script>

export default {
  name: 'pagination',
  components: {
  },
  props: ["Items", "value", "allSelected", "changeSelectAll", "selectAll"],
  data () {
    return {
      pages: this.value,
      options: [25 ,50, 100, 500]
    }
  },
  watched: {
    pages: function (val) {
      this.$emit('input', this.pages);
    }
  },
  methods:{
    nextPage(){
      if(this.pages.page < this.value.totalPage){
        this.pages.page = this.pages.page + 1;
      }
    },
    prevPage(){
      if(this.pages.page > 1){
          this.pages.page += -1;
      }
    }
  }
}
</script>

